import styled, { css } from "styled-components"

export const AuthContainer = styled.div`
  ${({ theme }) => {
    const { fonts, colors, spaces } = theme

    return css`
      display: grid;
      grid-template-columns: auto 1fr;
      grid-gap: ${spaces.large};

      color: ${colors.fg};
      background-color: ${colors.bg};
      margin: 0;
      min-height: 100vh;
      text-rendering: optimizeSpeed;

      flex-direction: column;
      align-items: center;
      height: -webkit-fill-available;
      -webkit-overflow-scrolling: touch;

      font-family: var(${fonts.family.primary});
      font-weight: ${fonts.weight.regular};
      overflow-x: hidden;
    `
  }}
`

export const Main = styled.main`
  margin: 0 auto;
  width: 90%;
  max-width: 25rem;
  height: 100%;
`

export const H1 = styled.h1`
  ${({ theme }) => {
    const { fonts, sizes } = theme

    return css`
      margin-top: ${sizes.large};
      margin-bottom: ${sizes.medium};
      font-size: ${fonts.size.heading1};
      font-weight: ${fonts.weight.regular};
      text-align: center;
    `
  }}
`
